import React from 'react';
import Component from './Component';
import DatePickerBase from 'react-datepicker';
import Moment from 'moment';

export default class DatePicker extends Component {

	static rules = {
		format: {
			pattern: /^(\d\d?[.]\d\d?[.]\d{4})|((\d{4})\D?(0[1-9]|1[0-2])\D?([12]\d|0[1-9]|3[01])(\D?([01]\d|2[0-3])\D?([0-5]\d)\D?([0-5]\d)?\D?(\d{3})?([zZ]|([\+-])([01]\d|2[0-3])\D?([0-5]\d)?)?)?)$/,
			message: 'Zadejte datum ve formátu d.m.RRRR!'
		},
		datetime: {
			message: 'Zadejte platné datum!'
		}
	};

	static defaultProps = {
		width: '100%',
		clearable: true
	};

	handleChange(value) {
		if (this.props.onChange) {
			this.props.onChange(value ? value.format('YYYY-MM-DD') : null)
		}
	}

	handleBlur(e) {
		if (this.props.onBlur) {
			this.props.onBlur(this.props.value);
		}
	}

	getError() {
		return this.props.error && this.props.error[0];
	}

	render() {
		let value = this.props.value;
		let mvalue = null;
		let selectedDate = value ? new Moment(value, 'YYYY-MM-DD') : null;
		const isValid = value ? selectedDate.isValid() : false;
		const isISO = isValid && (value == selectedDate.toISOString() ||
				value == Moment(selectedDate).format("YYYY-MM-DD") ||
				value == Moment(selectedDate).format("YYYY-MM-DD HH:mm:ss")
			);

		if (isValid) {
			if (isISO) {
				mvalue = new Moment(selectedDate);
			}
		}
		else {

		}

		return (
			<div className={this.getError() ? 'has-error' : ""}  style={{display: 'inline-block', width:this.props.width}}>
				<DatePickerBase {...this.props}
								className="form-control"
								locale="cs"
								isClearable={this.props.clearable}
								todayButton="Dnes"
								dateFormat="D.M.YYYY"
								selected={mvalue}
								onChange={(value) => this.handleChange(value)}
								onBlur={(e) => this.handleBlur(e)}
				/>
				{this.getError() && <div>{this.getError()}</div>}
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/reactis/reactis-inputs/DatePicker.js